import { Fragment } from "react"

import { define, prop } from "@/components/builder/utils"

import BasePreview from "../../base"

function MidpathTCPAContinueButtonPreview(props) {
  return <BasePreview {...props}>
    <button className="bt-continue tcpa-continue-button" type="button">Question Continue Button</button>
  </BasePreview>
}

export default define('tcpa-continue-button', MidpathTCPAContinueButtonPreview, Fragment)
  .shared(prop.share('MidpathTCPAContinueButton', 'tcpa-continue-button'), { prefix: false })
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultProps({
    background: {
      color: {
        hex: "#dadada",
      },
    },
    fontWeight: "font-bold",
    size: { width: "w-full" },
    customClassName: ["min-w-[200px]"],
    'customClassName-options': [{ label: "min-w-[200px]", value: "min-w-[200px]" }],
    space: { padding: 'py-2 px-3' },
    textAlign: { horizontal: 'center' },
    border: {
      radius: {
        rounded: "sm",
      },
    },
    cursor: 'cursor-pointer',
  })
  .build()
